export enum FeaturesEnum {
    HOME = 'Home',
    PTA_EXISTING_REQUESTS = 'PTA_Existing_Requests',
    PTA_NEW_REQUEST = 'PTA_New_Request',
    PREMIUM_CHECKLIST = 'PremiumCheckList',
    UPDATE_LPS_ROUTES = 'Update_LPS_Routes',
    CONFIRM_LPS_ROUTES = 'Confirm_LPS_Routes',
    SUPPLIER_DASHBOARD = 'Supplier_Dashboard',
    CARRIER_DASHBOARD = 'Carrier_Dashboard',
    ENGINEERING_DASHBOARD = 'Engineering_Dashboard',
    USER_MANAGEMENT = 'UserManagement',
    LOOKUPS_MANAGEMENT = 'Lookups_Management',
    SIGNOFF_CONTACTS = 'Signoff_Contacts',
    PTA_CONFIG = 'PTA_Configuration',
    ROLE_PERMISSIONS = 'Role_Permissions',
    TICKETS_DASHBOARD = 'Tickets_Dashboard',
    TEST_CASES = 'Test_Cases',
    LOG_TICKET = 'Log_Ticket',
    TICKET_QUEUE = 'Ticket_Queue',
}